<template>
    <div v-if="this.$route.params.id">
        <b-field position="is-center">
            <input v-model="input_text" type="text" v-on:keyup.enter="enter_search" placeholder=" キーワードを入力" id="">
            <p class="control">
                <b-button @click="search" type="is-info">検索</b-button>
            </p>
        </b-field>
        <hr>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                input_text: null,
                enter_text: "",
            }
        },
        methods:{
            search(){
                //スペースがあるか？ある場合は複数検索へ飛ばす「\s+」は空白の正規表現
                if(this.input_text.match(/\s+/)){
                    this.$router.push({ name: 'keywords', params:{ id: this.input_text} })
                    this.input_text = null
                    this.enter_text = ""
                }else{
                    this.$router.push({ name: 'article', params:{ id: this.input_text} })
                    this.input_text = null
                    this.enter_text = ""
                }
            },
            enter_search(){
                //二回エンターを押したかどうかの判定
                if(this.input_text == this.enter_text){
                    //スペースがあるか？ある場合は複数検索へ飛ばす「\s+」は空白の正規表現
                    if(this.input_text.match(/\s+/)){
                        this.$router.push({ name: 'keywords', params:{ id: this.input_text} })
                        this.input_text = null
                        this.enter_text = ""
                    }else{
                        this.$router.push({ name: 'article', params:{ id: this.input_text} })
                        this.input_text = null
                        this.enter_text = ""
                    }
                }else{
                    this.enter_text = this.input_text
                }
            }
        }
    }
</script>

<style scoped>
input{
  width: 300px;
  border: 1px solid gray;
  font-size:1.1em;
  border-radius: 3px;
  padding-left: 10px;
}
hr{
  margin-top: 8px;
  margin-bottom: 8px;
}

</style>
